const setDemoBuilderPageTitle = (step) => {
    const titles = new Map([
        [1, "Step 1: Company Information | Principal Web Demo Builder"],
        [2, "Step 2: Featured Demos | Principal Web Demo Builder"],
        [3, "Step 3: Demo Options | Principal Web Demo Builder"],
    ]);

    document.title = titles.get(step) || "Principal Web Demo Builder";
};

export default setDemoBuilderPageTitle;